import cloneDeep from 'lodash/cloneDeep'
import merge from 'lodash/merge'
import { transfCssUtil, execStyle, genAnimationAttrs } from '../utils/index'
import { loadFolderFiles } from './loadFiles'
import '../style/cmsElement.styl'

const componentChild = {}
/**
 * 将./slots中的文件挂载到对象componentChild上
 * 文件名为key，对应JSON配置中的__config__.tag
 * 文件内容为value，解析JSON配置中的__slot__
 */
const slotsFiles = require.context('./slots', false, /\.js$/)
const keys = slotsFiles.keys() || []
keys.forEach(key => {
  const tag = key.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = slotsFiles(key).default
  componentChild[tag] = value
})

function vModel (dataObject, confClone) {
  const config = confClone.__config__
  dataObject.props.value = config.defaultValue

  dataObject.on.input = val => {
    this.$emit('input', val)
  }

  dataObject.on.curClickNode = val => {
    this.$emit('curClickNode', val)
  }

  dataObject.on.chooseNpsData = val => {
    this.$emit('input', val)
  }

  // 快速建站时需要触发数据到外部修改
  dataObject.on.AddFastSiteEdit = val => {
    this.$emit('AddFastSiteEdit', val)
  }
}

function mountSlotFiles (h, confClone, children, dataObject) {
  const childObjs = componentChild[confClone.__config__.tag]
  if (childObjs) {
    Object.keys(childObjs).forEach(key => {
      const childFunc = childObjs[key]
      if (
        confClone.__slot__ && confClone.__slot__[key] ||
        confClone.topicData && confClone.topicData[key]
      ) {
        children.push(childFunc.call(this, h, confClone, key, this.child))
      }
    })
  }
}

/**
 * 事件监听器
 * @param {*} confClone
 */
function emitEvents (confClone) {
  ['on'].forEach(attr => {
    const eventList = Object.keys(confClone[attr] || {})
    eventList.forEach(key => {
      const val = confClone[attr][key]
      if (typeof val === 'string') {
        confClone[attr][key] = event => this.$emit(val, event, confClone)
      }
    })
  })
}

/**
 * 加载所有的属性事件
 */
function mountAttrEvent (h, confClone, dataObject) {
  const attrEvent = require.context('./attrEvent', false, /\.js$/)
  const filesCol = loadFolderFiles(attrEvent)
  const events = filesCol[confClone.__config__.tag]
  for (const prop in events) {
    dataObject.attrs[prop] = events[prop].call(this, h, confClone)
  }
}

/**
 * 将配置文件数据设置到jsx - 深入数据对象
 * 具体可以查看vue官网渲染函数&jsx
 * @param {*} confClone
 * @param {*} dataObject
 */
function buildDataObject (confClone, dataObject) {
  Object.keys(confClone).forEach(key => {
    const keyVal = confClone[key]
    // 给每个组件增加ID
    dataObject.attrs.id = `field_${confClone.__config__.renderKey}`
    // 如果是vModel
    if (key === '__vModel__') {
      vModel.call(this, dataObject, confClone)
    } else if (key in dataObject) {
      if (Object.prototype.toString.call(keyVal) === '[object Object]') { // 对象赋值
        if (key === 'style') {
          dataObject[key] = transfCssUtil(confClone.style)
          execStyle.call(this, confClone, dataObject, key)
        } else {
          dataObject[key] = { ...dataObject[key], ...keyVal }
        }
      } else if (Object.prototype.toString.call(keyVal) === '[object Array]') { // 数组赋值
        dataObject[key] = [...keyVal]
      } else if ( // 基本类型赋值
        ['boolean', 'string', 'number'].includes(typeof dataObject[key])
      ) {
        dataObject[key] = keyVal
      }
    } else {
      if (key === 'componentAnimation' && keyVal['scrollAnimation'] && this.mode !== 'edit' && this.globalScrollAnimation) {
        // 给开启滚动动画的每个组件添加 data-aos 开头属性，用于触发 AOS.init 动画（注：编辑模式不开启动画）
        genAnimationAttrs(keyVal['scrollAnimation'], dataObject)
      }
      dataObject.attrs[key] = keyVal
      // 移动端tabs固定top
      if (key === 'tabPosition' && document.documentElement.clientWidth < 768) {
        dataObject.attrs[key] = 'top'
      }
      if (key === '__slot__' && keyVal['options']) {
        dataObject.attrs['__childOptionsConfig__'] = keyVal['options']
      } 
    }
  })

  // 清理属性
  clearAttrs(dataObject, confClone)
}

/**
 * 将私有属性配置清除 无需传递到组件内
 * @param {*} dataObject 
 * @param {*} confClone 
 */
function clearAttrs (dataObject, confClone) {
  // delete dataObject.attrs.__config__
  delete dataObject.attrs.__slot__
  delete dataObject.attrs.__methods__
  delete dataObject.attrs.__senior__
  delete dataObject.attrs.componentAnimation
}

function makeDataObject (extra = {}) {
  return {
    class: {},
    attrs: Object.assign({}, extra),
    props: {},
    domProps: {},
    // nativeOn: {},
    on: {},
    style: {},
    directives: [],
    scopedSlots: {},
    slot: null,
    key: null,
    ref: null,
    refInFor: true
  }
}

import TextEdit from './TextEdit.vue'
export default {
  props: {
    conf: {
      type: Object,
      required: true
    },
    headers: {
      type: Function
    },
    child: {
      type: [Object, Array]
    },
    mode: {
      type: String,
      default: 'view'
    },
    readDevice: {
      type: String,
      default: 'pc'
    }
  },
  components: {
    TextEdit
  },
  inject: ['globalScrollAnimation'],
  render (h) {
    const dataObject = makeDataObject({ mode: this.mode })
    const copyConf = cloneDeep(this.conf)
    const activeDeviceData = copyConf[this.readDevice] || {}
    const confClone = merge({}, copyConf, activeDeviceData)
    // const confClone = cloneDeep(this.conf)
    const children = this.$slots.default || []
    // 如果slots文件夹存在与当前tag同名的文件，则执行文件中的代码
    mountSlotFiles.call(this, h, confClone, children, dataObject)

    // 加载所有组件的事件
    mountAttrEvent.call(this, h, confClone, dataObject)

    // 将字符串类型的事件，发送为消息
    emitEvents.call(this, confClone)

    // 将json表单配置转化为vue render可以识别的 “数据对象（dataObject）”
    buildDataObject.call(this, confClone, dataObject)

    return h(this.conf.__config__.tag, dataObject, children)
  }
}
